//-------------------------------------------------------------------------------------------------- Imports
import { Button, Col, Row } from "antd";
import { StyleSheet } from "../../StyleSheet";
import InfoCardComponent from "../../components/InfoCardComponent";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import PaymentAmount from "./components/PaymentAmount";
import PaymentCardData, { CardPaymentProps } from "./components/PaymentCardData";
import { useCallback, useEffect, useState } from "react";
import { encryptCreditCard, getExpirationCard, getPaymentsGeneral, getPaymentsSavedCard, getRecentPayment, payWithCard, saveCard } from "../../methods/Methods";
import { RequestPayWithCardEncrypted, RequestPayWithCardPayment, ResponsePaymentGeneral, ResponseSuscriptorDataGeneralDatum, Tarjeta } from "../../types/common";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import Loading from "../../components/Loading";
import moment from "moment";
import { AppDispatch } from "../../stores/store";
import { AlertSliceInterface, clearAlert, setAlert, showAlert } from "../../stores/slices/alertSlice";
import { clearPaymentData, getPaymentDataContracts, setPaymentDataToContract } from "../../stores/slices/paymentDataSlice";
import { useNavigate } from "react-router-dom";
import { cifrarAES } from "../../assets/Encrypt";

export interface errorFieldsProps {
    creditCard: string,
    expirationCard?: string,
    cvvCard?: string,
    expirationCardSaved?: string
    cvvCardSaved?: string
}

interface CreditCardObj {
    tarjeta: string,
    tipo: string
}

//-------------------------------------------------------------------------------------------------- View
const PaymentCard = () => {
    const generalData = useSelector(getGeneralData);
    const paymentDataRedux = useSelector(getPaymentDataContracts);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [paymentData, setPaymentData] = useState<ResponsePaymentGeneral>();
    const [savedCard, setSavedCard] = useState<string>("");
    const [idCliente, setIdCliente] = useState<string>("");
    const [packageName, setPackageName] = useState<string>("");
    const [dataClient, setDataClient] = useState<ResponseSuscriptorDataGeneralDatum>();
    const [hasError, setHasError] = useState(false);
    const [recurrentCard, setRecurrentCard] = useState<Tarjeta | null>();
    const [messageInfoCard, setMessageInfoCard] = useState("");
    const [hasPayment, setHasPayment] = useState<boolean>(false);
    const [messageHasPayment, setMessageHasPayment] = useState("");
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const pad = (textoArellenar: string, length: number): string => {
        let padding = 0;
        var str = textoArellenar + "";
        return (length <= str.length) ? str : pad(padding + str, length);
    }

    const updateCard = async (cardNumToUpdate: string) => {
        // quita los guiones con los que se guardaba en el input // split("-").join('')
        saveCardFnt(cardNumToUpdate.split("-").join(''), "actualizacion")
    }

    const isCardExpired = useCallback(() => {
        if (recurrentCard) {
            let mesActual = Number(moment().format("MM"));
            let anioActual = Number(moment().format("YYYY"));
            // Revisa si la tarjeta que tiene guardada está expirada
            if ((recurrentCard.vencimiento.anio === anioActual && recurrentCard.vencimiento.mes < mesActual) || (recurrentCard.vencimiento.anio < anioActual)) {
                return true;
            }
            return false;
        }
    }, [recurrentCard]);

    const handleDispatchStatusPay = useCallback((navigateTo: string | null, onPressSaveCardFinalized: Function | null) => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
        if (!_.isNull(navigateTo)) {
            navigate(navigateTo);
        }
        if (!_.isNull(onPressSaveCardFinalized)) {
            onPressSaveCardFinalized();
        }
    }, [dispatch, navigate]);

    const openAlertModal = useCallback((option: AlertSliceInterface) => {
        dispatch(setAlert({
            show: option.show,
            type: option.type as "INFO" | "SUCCESS" | "ERROR",
            title: option.title,
            message: option.message,
            extraComponents: option.extraComponents,
            onFinalize: option.onFinalize,
            isReceiptPayment: option.isReceiptPayment,
            paymentData: option.paymentData
        }));
    }, [dispatch]);

    const showRecurrentOption = useCallback(() => {
        let messageStatus = "";
        // Si tiene domiciliado 
        if (!_.isNull(recurrentCard)) {
            if (isCardExpired()) {
                // Si está expirada
                //Se muestra alert con opcion de domiciliar
                messageStatus = "La tarjeta con la que tiene el pago domiciliado de su servicio está expirada. \n¿Le gustaría actualizarla?"
                let dispatchStatusPay: AlertSliceInterface = {
                    show: true,
                    type: "SUCCESS",
                    title: "¡Estimado Usuario!",
                    message: messageStatus,
                    onFinalize: undefined,
                    extraComponents:
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%' }}>
                            <Button
                                style={styles.buttonStyle}
                                onClick={() => handleDispatchStatusPay("/payments/monthly-payment", null)}
                            >
                                Domiciliar
                            </Button>
                            <Button
                                style={styles.buttonStyle}
                                onClick={() => handleDispatchStatusPay("/payments", null)}
                            >
                                Ahora no
                            </Button>
                        </div>,
                }

                openAlertModal(dispatchStatusPay);
            } else {
                // y si esta vigente Navega a pagos.
                navigate("/payments");
            }
        } else {
            // Si no tiene domiciliado
            //Se muestra alert con opcion de domiciliar
            messageStatus = "Usted aún no cuenta con el pago domiciliado de su servicio. \n¿Le gustaría domiciliar su servicio?";
            let dispatchStatusPay: AlertSliceInterface = {
                show: true,
                type: "SUCCESS",
                title: "¡Estimado Usuario!",
                message: messageStatus,
                onFinalize: undefined,
                extraComponents:
                    <div style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%' }}>
                        <Button
                            style={styles.buttonStyle}
                            onClick={() => handleDispatchStatusPay("/payments/monthly-payment", null)}
                        >
                            Domiciliar
                        </Button>
                        <Button
                            style={styles.buttonStyle}
                            onClick={() => handleDispatchStatusPay("/payments", null)}
                        >
                            Ahora no
                        </Button>
                    </div>,
            }
            openAlertModal(dispatchStatusPay);
        }
    }, [isCardExpired, navigate, recurrentCard, openAlertModal, handleDispatchStatusPay]);

    const onPressSaveCardFinalized = useCallback(async () => {
        // muestra opciones de domiciliacion si aplica
        showRecurrentOption();
    }, [showRecurrentOption]);


    const saveCardFnt = useCallback(async (cardNumber: string, typeOption: string) => {
        let cardEncrypted: string = "";
        await encryptCreditCard(idCliente, cardNumber)
            .then((response) => {
                if (response.data && response.data.data[0]) {
                    cardEncrypted = response.data.data[0].creditCardEncrypted;
                }
            })
            .catch(() => {
            })
        let creditCardObj: CreditCardObj = {
            tarjeta: cardEncrypted,
            tipo: typeOption
        }
        let typeStatus = "";
        let messageStatus = "";
        if (!_.isEmpty(cardEncrypted)) {
            setIsLoading(true);
            await saveCard(creditCardObj, idCliente)
                .then((response) => {
                    if (response && response.data && response.data.data[0]) {
                        if (_.isEqual(response.data.data[0].estatus, "true")) {
                            typeStatus = "SUCCESS";
                        } else {
                            typeStatus = "ERROR";
                        }
                    }
                    messageStatus = response.data.data[0].mensaje;
                    let dispatchStatusPay: AlertSliceInterface = {
                        show: true,
                        type: typeStatus as "INFO" | "SUCCESS" | "ERROR",
                        title: "¡Estimado Usuario!",
                        message: messageStatus,
                        onFinalize: undefined,
                        extraComponents:
                            <Button style={styles.buttonStyle} onClick={() => handleDispatchStatusPay(null, onPressSaveCardFinalized)}>
                                Aceptar
                            </Button>
                    }
                    openAlertModal(dispatchStatusPay);
                    setIsLoading(false);
                })
                .catch(() => {
                    typeStatus = "ERROR";
                    messageStatus = "Hubo un error al guardar su tarjeta. \nIntente más tarde.";
                    let dispatchStatusPay: AlertSliceInterface = {
                        show: true,
                        type: typeStatus as "INFO" | "SUCCESS" | "ERROR",
                        title: "¡Estimado Usuario!",
                        message: messageStatus,
                        onFinalize: undefined,
                        extraComponents:
                            <Button style={styles.buttonStyle} onClick={() => handleDispatchStatusPay("/payments", null)}>
                                Aceptar
                            </Button>
                    }
                    openAlertModal(dispatchStatusPay);
                    setIsLoading(false);
                })
        } else {
            typeStatus = "ERROR";
            messageStatus = "Ocurrió un error inesperado y no se guardó su tarjeta. \nIntente más tarde.";
            let dispatchStatusPay: AlertSliceInterface = {
                show: true,
                type: typeStatus as "INFO" | "SUCCESS" | "ERROR",
                title: "¡Estimado Usuario!",
                message: messageStatus,
                onFinalize: undefined,
                extraComponents:
                    <Button style={styles.buttonStyle} onClick={() => handleDispatchStatusPay("/payments", null)}>
                        Aceptar
                    </Button>
            }
            openAlertModal(dispatchStatusPay);
        }
    }, [idCliente, handleDispatchStatusPay, onPressSaveCardFinalized, openAlertModal]);

    const onPressFinishPayment = useCallback(async (typeStatus: string, cardDataToPay: CardPaymentProps | null) => {
        // si el proceso del pago fue exitoso
        if (_.isEqual(typeStatus, "SUCCESS")) {
            if (cardDataToPay && cardDataToPay.toSaveCard && cardDataToPay.number) {
                // Si quiso guardar tarjeta
                saveCardFnt(cardDataToPay.number, cardDataToPay.isNewCard ? "nueva" : "actualizacion");
            } else {
                // Si no quiso guardar tarjeta
                // muestra opciones de domiciliacion
                showRecurrentOption();
            }
        } else {
            // si el proceso del pago fue con error
            // navega a pagos
            navigate("/payments")
        }
    }, [saveCardFnt, showRecurrentOption, navigate]);

    const getPaymentData = useCallback(async () => {
        setIsLoading(true);
        await getPaymentsGeneral(idCliente)
            .then(async (responsePayments) => {
                if (responsePayments.data && responsePayments.data[0]) {
                    let recurrentCard: Tarjeta | null = null;
                    await getExpirationCard(idCliente)
                        .then((response) => {
                            if (response.data && response.data.data[0]) {
                                //Si el campo tarjeta no está null es porque tiene tarjeta domiciliada
                                //Y si es diferente del cod 902
                                if (!_.isNull(response.data.data[0].tarjeta) && response.data.data[0].codigo !== "902") {
                                    recurrentCard = response.data.data[0].tarjeta;
                                    setRecurrentCard(response.data.data[0].tarjeta);
                                }
                            }
                        })
                        .catch(() => {
                        });

                    setPaymentData(responsePayments.data[0]);
                    dispatch(setPaymentDataToContract({
                        clientId: idCliente,
                        paymentData: responsePayments.data[0],
                        recurrentCard: recurrentCard
                    }));
                }
                else {
                    setPaymentData(undefined);
                }
                setIsLoading(false);
            }).catch(() => {
                setHasError(true);
                setMessageInfoCard("Hubo un error al procesar su solicitud. \nIntente más tarde.");
                setPaymentData(undefined);
                setIsLoading(false);
            });
    }, [dispatch, idCliente]);

    const getCardSaved = useCallback(async () => {
        if (!_.isEmpty(idCliente)) {
            setIsLoading(true);
            await getPaymentsSavedCard(idCliente)
                .then((response) => {
                    if (response.data.data[0]) {
                        if (!_.isEmpty(response.data.data[0])) {
                            setSavedCard(response.data.data[0].tarjeta);
                        }
                    }
                    setIsLoading(false);
                })
                .catch(() => {
                    setIsLoading(false);
                })
        }
    }, [idCliente]);

    const doPayment = async (cardDataToPay: CardPaymentProps | null) => {
        if (paymentData && paymentData.payment.datos && dataClient) {
            let datePayFormat = paymentData.payment.datos.paymentLimitDate.split('-');
            let dateLimitPay = datePayFormat[0].padStart(2, "0") + moment().month(datePayFormat[1]).format("MM") + datePayFormat[2];
            let amountToPayment = pad(paymentData.payment.datos.amount.replace(/[.,]/g, ""), 7);
            if (cardDataToPay) {
                let typeStatus = "";
                let messageStatus = "";
                let payment: RequestPayWithCardPayment = {
                    reference: dataClient.sucursal + dataClient.suscriptor + dateLimitPay + amountToPayment,
                    name: dataClient.nombre + " " + dataClient.apellidoPaterno + " " + dataClient.apellidoMaterno,
                    number: cardDataToPay.number,
                    expmonth: cardDataToPay.expirationDateCard.substring(0, 2),
                    expyear: cardDataToPay.expirationDateCard.substring(2, 4),
                    cvv: cardDataToPay.cvvCard,
                    amount: paymentData.payment.datos.amount.replace(/[,]/g, ""),
                }
                const encryptedData = cifrarAES(payment, "5DCC67393750523CD165F17E1EFADD21");
                let dataToPayment: RequestPayWithCardEncrypted = {
                    payment: encryptedData
                };
                setIsLoading(true);
                await payWithCard(dataToPayment, dataClient.sucursal + dataClient.suscriptor)
                    .then((response) => {
                        // Se pregunta si la respuesta no está vacía.
                        if (response.data && response.data.data[0]) {
                            //error
                            if (_.isEqual(response.data.data[0].data.status, "0") && _.isEmpty(response.data.data[0].data.folio)) {
                                typeStatus = "ERROR";
                                messageStatus = response.data.data[0].data.message;
                                // status === 0 && folio === 0. Error de validacion proxy / conexion / problemas al realizar pago.
                            } else if (_.isEqual(response.data.data[0].data.status, "0") && _.isEqual(response.data.data[0].data.folio, "0")) {
                                typeStatus = "ERROR";
                                messageStatus = response.data.data[0].data.message ? response.data.data[0].data.message : "Error de validacion proxy / conexion / problemas al realizar pago."
                            } else if (_.isEqual(response.data.data[0].data.status, "1") && _.isEqual(response.data.data[0].data.folio, "-1")) {
                                typeStatus = "ERROR";
                                messageStatus = response.data.data[0].data.message ? response.data.data[0].data.message : "Hubo un inconveniente al procesar su pago, para más información comuníquese con su institución bancaria."
                                //pay_invalid_card_internet
                            } else if (_.isEqual(response.data.data[0].data.status, "1") && _.isEqual(response.data.data[0].data.folio, "0")) {
                                typeStatus = "ERROR";
                                messageStatus = response.data.data[0].data.message ? response.data.data[0].data.message : "Tarjeta no válida para pagos por internet."
                            } else if (_.isEqual(response.data.data[0].data.status, "1") && Number(response.data.data[0].data.folio) > 1) {
                                let success = response.data.data[0].data.message + "\nSe ha realizado con éxito \nel pago de su contrato " + idCliente;
                                let amount = ", \npor un monto de $" + response.data.data[0].data.totalCompra;
                                let creditCard = " con su tarjeta con terminación ***" + response.data.data[0].data.numeroTarjeta;
                                messageStatus = success + amount + creditCard;
                                typeStatus = "SUCCESS";
                                dispatch(clearPaymentData());
                            } else {
                                typeStatus = "ERROR";
                                messageStatus = response.data.data[0].data.message;
                            }
                            let dispatchStatusPay: AlertSliceInterface;
                            if (typeStatus === "SUCCESS") {
                                // Separar la fecha y la hora del string
                                const [fechaString, horaString] = response.data.data[0].data.fechaCompra.split(" - ");
                                dispatchStatusPay = {
                                    show: true,
                                    type: typeStatus as "INFO" | "SUCCESS" | "ERROR",
                                    title: "¡Estimado Usuario!",
                                    message: messageStatus,
                                    isReceiptPayment: true,
                                    paymentData: {
                                        amount: response.data.data[0].data.totalCompra,
                                        card: "******" + response.data.data[0].data.numeroTarjeta,
                                        client: idCliente,
                                        name: dataClient?.nombre + " " + dataClient?.apellidoPaterno + " " + dataClient?.apellidoMaterno,
                                        date: fechaString,
                                        time: horaString,
                                        concept: dataClient?.paquete
                                    },
                                    onFinalize: () => handleDispatchStatusPay(null, () => onPressFinishPayment(typeStatus, cardDataToPay))
                                }
                            } else {
                                dispatchStatusPay = {
                                    show: true,
                                    type: typeStatus as "INFO" | "SUCCESS" | "ERROR",
                                    title: "¡Estimado Usuario!",
                                    message: messageStatus,
                                    onFinalize: () => handleDispatchStatusPay(null, () => onPressFinishPayment(typeStatus, cardDataToPay))
                                }
                            }
                            openAlertModal(dispatchStatusPay);
                            setIsLoading(false);
                        }
                    })
                    .catch(() => {
                        typeStatus = "ERROR";
                        messageStatus = "Transacción en proceso de revisión. Si el pago fué aprobado por su banco, en un máximo de 48 horas será aplicado de forma automática por el sistema.";
                        let dispatchStatusPay: AlertSliceInterface = {
                            show: true,
                            type: typeStatus as "INFO" | "SUCCESS" | "ERROR",
                            title: "¡Estimado Usuario!",
                            message: messageStatus,
                            onFinalize: () => handleDispatchStatusPay(null, () => onPressFinishPayment(typeStatus, null))
                        }
                        openAlertModal(dispatchStatusPay);
                        setIsLoading(false);
                    });
            }
        }
    };

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            setIdCliente(
                generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor
            );
            setPackageName(generalData.selectedContract.paquete)
            setDataClient(generalData.selectedContract);
        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        if (idCliente) {
            setIsLoading(true);
            getRecentPayment(idCliente)
                .then((response) => {
                    if (response.data.data[0].status) {
                        if (response.data.data[0].hasPayment) {
                            setMessageHasPayment(response.data.data[0].message);
                            setHasPayment(true);
                        }
                        setIsLoading(false);
                    } else {
                        setMessageHasPayment("Por el momento no es posible mostrar información de su contrato, intente más tarde.");
                        setHasPayment(true);
                        setIsLoading(false);
                    }
                })
                .catch(() => {
                    setMessageHasPayment("Por el momento no es posible mostrar información de su contrato, intente más tarde.");
                    setHasPayment(true);
                    setIsLoading(false);
                })
        }
    }, [idCliente]);

    useEffect(() => {
        if (idCliente) {
            const index = paymentDataRedux.contracts.findIndex(obj => obj.clientId === idCliente);

            if (index >= 0) {
                setPaymentData(paymentDataRedux.contracts[index].paymentData);
                setRecurrentCard(paymentDataRedux.contracts[index].recurrentCard);
            }
            else {
                getPaymentData();
            }
        }
    }, [idCliente, getPaymentData, paymentDataRedux.contracts]);

    useEffect(() => {
        if (idCliente) {
            getCardSaved()
        }
    }, [getCardSaved, idCliente]);

    return (
        <>
            {
                // Se le agregó la condicion de || _.isNull(paymentData) 
                // para que no aparezca que no tiene adeudo antes de tiempo
                isLoading || _.isNull(paymentData) ?
                    <Loading />
                    :
                    <SubDefaultLayout title={"Pago con Tarjeta"} needReturn={true} navigateTo={"/payments"}>
                        <div style={{ marginTop: 20 }}>
                            {
                                hasError ?
                                    <InfoCardComponent title="¡Estimado usuario!" description={messageInfoCard} />
                                    :
                                    <>
                                        <InfoCardComponent title="¡Estimado usuario!" description="Por el momento no aceptamos pagos con American Express." />
                                        <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
                                            <Col xs={24} md={11} lg={12}>
                                                <PaymentAmount paymentData={paymentData} packageName={packageName} />
                                            </Col>
                                            <Col xs={24} md={13} lg={12}>
                                                {
                                                    paymentData?.payment.datos && !_.isEmpty(paymentData?.payment.datos.amount) && paymentData?.payment.datos.amount !== "0.00" ?
                                                        <>
                                                            {
                                                                hasPayment ?
                                                                    <InfoCardComponent color="#FFC439" colorText="#000" description={messageHasPayment} />
                                                                    :
                                                                    <PaymentCardData
                                                                        cardNumSaved={savedCard}
                                                                        dataClient={dataClient}
                                                                        doPayment={doPayment}
                                                                        updateCard={updateCard}
                                                                    />
                                                            }
                                                        </>
                                                        :
                                                        <InfoCardComponent title="¡No tienes adeudos!" />
                                                }
                                            </Col>
                                        </Row>
                                    </>
                            }
                        </div>
                    </SubDefaultLayout>
            }
        </>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    buttonStyle: {
        height: 40,
        fontSize: 18,
        fontWeight: 600,
        padding: "0px 40px 0px 40px",
        borderRadius: 20,
        border: "none",
        color: "#ffffff",
        backgroundColor: "#0055c2",
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default PaymentCard;
